import _ from 'lodash';
//import debounce from 'lodash/debounce';

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import Map from '../../shared/components/Map';

import { Spin, Icon, Radio } from 'antd';

import Geocoder from '../../shared/components/Geocoder';
import { ActionButton } from '../../shared/components/ActionButton';

import {setBounds, setCenter} from '../../shared/actions';
import { resetPOI, serverLoadPOI, serverUpdatePOICenter, sagaPatchPOI } from '../../pois/actions';

import { serverMarkPOIValidationStageComplete, serverMarkPOIUnsure } from '../actions';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const green = '#03DAC4';
const yellow ='#F0DA3B';

class ValidationFixPOICenter extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            googlePlaces: [],
        };
    }
    // Event handlers
    componentWillMount(){
        let poiId = this.props.match.params.poi_id;
        this.props.getPoi(poiId);
    }

    componentDidMount(){
        let poiId = this.props.match.params.poi_id;
        this.context.mixpanel.track('validation', {
            task: 'fixPOICenter',
            poiId,
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.poi_id !== this.props.match.params.poi_id) {
            let poiId = nextProps.match.params.poi_id;
            nextProps.getPoi(poiId);
            this.setState({ googlePlaces: [] });
        }
    }

    onMarkerChange(poiId, marker){
        this.props.patchPOI(poiId, {
            geo: marker,
        });
    }

    showGoogleMapsLocations() {
        if (!window.google || !window.google.maps) return;
        
        let poiId = this.props.match.params.poi_id;
        const tmp = this.props.poiInfo.get(poiId);
        if (!tmp || !tmp.poi) return;
        const poi = tmp.poi;
        
        let coords = null;
        if (poi.location && poi.location.coordinates) {
            coords = poi.location.coordinates;
        } else if (poi.geo && poi.geo.coordinates) {
            coords = poi.geo.coordinates;
        }
        if (!coords) return;
        
        const center = new window.google.maps.LatLng(coords[1], coords[0]);
        
        const request = {
            textQuery: poi.organizationName,
            locationBias: {
                center: center,
                radius: 2000
            },
            fields: ['id', 'displayName', 'formattedAddress', 'location']
        };

        if (window.google.maps.places.Place && window.google.maps.places.Place.searchByText) {
            window.google.maps.places.Place.searchByText(request).then(({ places }) => {
                if (places && places.length > 0) {
                    const googlePlaces = places.map(p => ({
                        _id: p.id,
                        name: p.displayName || p.formattedAddress,
                        formattedAddress: p.formattedAddress,
                        draggable: false,
                        icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
                        location: {
                            type: 'Point',
                            coordinates: [p.location.lng(), p.location.lat()]
                        }
                    }));
                    this.setState({ googlePlaces });
                }
            }).catch(e => {
                // eslint-disable-next-line no-console
                console.error("Error fetching places:", e);
            });
        } else {
            const dummyElement = document.createElement('div');
            const service = new window.google.maps.places.PlacesService(dummyElement);
            
            const legacyRequest = {
                location: center,
                radius: '2000',
                query: poi.organizationName
            };
            
            service.textSearch(legacyRequest, (results, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    const googlePlaces = results.map(r => ({
                        _id: r.place_id,
                        name: r.name,
                        formattedAddress: r.formatted_address,
                        draggable: false,
                        icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
                        location: {
                            type: 'Point',
                            coordinates: [r.geometry.location.lng(), r.geometry.location.lat()]
                        }
                    }));
                    this.setState({ googlePlaces });
                }
            });
        }
    }
    
    render(){
        const { props } = this;

        let poiId = props.match.params.poi_id;
        const tmp = props.poiInfo.get(poiId);

        if (_.isUndefined(tmp)) {
            return(
                <div style={{ textAlign: 'center', verticalAlign: 'center', paddingTop: '30%' }}>
                    <Spin indicator={antIcon} />
                </div>
            )
        }
        const poi = tmp.poi;

        const pois = [poi, ...this.state.googlePlaces];

        return(
            <div style={{ width: '100%', height: '100%', padding: '15px 20px', overflowY: 'scroll' }}>
                <div>
                    <Geocoder onResultSelect={(result) => {
                        this.props.setMapBounds(result.bounds);
                    }} />
                </div>
                <div style={{width: '100%', height: '48vh'}}>
                    <Map {...props} pois={pois}
                        drawOnlyTopFence={false} fences={[]} draggableMarkers
                        showGeocode={false} drawMode={false} editMode={false}
                        onMarkerChange={this.onMarkerChange.bind(this)}
                    />
                </div>
                <div>
                    <span className="field">
                            <span className="label">POI name</span>
                            <h4 className="heading-level-2">
                                <a href="">{`${poi.organizationName} > ${poi.name}`}</a>
                            </h4>
                        </span>
                    <p className="inline-content">{poi.formattedAddress}</p>
                    <ActionButton 
                        style={{ marginTop: '10px', marginBottom: '10px' }}
                        onClick={this.showGoogleMapsLocations.bind(this)}>
                        Show googlemaps locations
                    </ActionButton>
                </div>
                    
                <div>
                    <div className="field">
                    <span className="label">Select building center type</span>
                    <Radio.Group defaultValue={poi.poiCenterType} ref={this.setBuildingTypeRef} onChange={(e) => {
                        this.props.patchPOI(poiId, { centerType: e.target.value });
                    }}>
                        <Radio.Button value="building">POI Building</Radio.Button>
                        <Radio.Button value="main_building">Larger Building</Radio.Button>
                        <Radio.Button value="no_building">No Building</Radio.Button>
                    </Radio.Group>
                    </div>
                </div>
                <div className="button-group">
                    <ActionButton 
                        style={{ backgroundColor: yellow}}
                        onClick={() => {
                            props.markPOIUnsure(poiId, {});
                        }}>
                        Unsure
                    </ActionButton>

                    <ActionButton 
                        style={{ backgroundColor: green}}
                        disabled={!poi.poiCenterType}
                        onClick={() => {
                            props.markAsValidated(poiId);
                        }}>
                        Correct
                    </ActionButton>
                </div>
            </div>
        )
    }
}


ValidationFixPOICenter.propTypes = {
  fencesMap: PropTypes.instanceOf(Immutable.Map),
  poiInfo: PropTypes.instanceOf(Immutable.Map),
  match: PropTypes.shape({
    params: PropTypes.shape({
      'poi_id': PropTypes.string,
    })
  }),
  setMapBounds: PropTypes.func,
  getPoi: PropTypes.func,
  markAsValidated: PropTypes.func,
  markPOIUnsure: PropTypes.func,
  updatePOICenter: PropTypes.func,
  patchPOI: PropTypes.func,
}

ValidationFixPOICenter.contextTypes = {
    mixpanel: PropTypes.object.isRequired,
};


// Map props to the store

const mapStateToProps = (state) => ({
  mapCenter: state.common.getIn(['center']),
  mapBounds: state.common.getIn(['bounds']),
  fencesMap: state.routes.validation.get('fencesMap'),
  poiInfo: state.routes.pois.server.get('poisMap'),
  POIDuplicatesMap: state.routes.pois.server.get('duplicatesMap'),
  geocodeResults: state.geocode.results,
  drawMode: true,
  editMode: true,
  draggableMarkers: false,
  key: 'fenceEditMap',
});

const mapDispatchToProps = (dispatch) => ({
  centerChanged: ()=>{
    dispatch(setCenter(null));
  },
  selectNewFenceMapCenter: ()=>{
  },
  setMapBounds: (bounds)=>{
    dispatch(setBounds(bounds));
  },
  updatePOICenter: (poiId, geo, centerType) => {
    dispatch(serverUpdatePOICenter(poiId, geo, centerType));
  },
  patchPOI: (poiId, body) => {
    dispatch(sagaPatchPOI(poiId, body));
  },
  getPoi: (poiId)=>{
    dispatch(resetPOI(poiId));
    dispatch(serverLoadPOI(poiId));
  },
  markAsValidated: (poiId) => {
      dispatch(serverMarkPOIValidationStageComplete(poiId, 'fixPOICenter'));
  },
  markPOIUnsure: (poiId) => {
      dispatch(serverMarkPOIUnsure(poiId));
  },
})

const ValidationPOIOrganizationContainer = connect(mapStateToProps,mapDispatchToProps)(ValidationFixPOICenter);

export default ValidationPOIOrganizationContainer;


// WEBPACK FOOTER //
// ./src/validation/components/ValidationFixPOICenter.js